const SELECTORS = {
	inputSelect: 'reasonSelect',
	textareaWrapper: 'reasonTextareaWrapper',
	textarea: 'reason',
	countDownLength: 'countDownLength',
	submitButton: 'declineBookingButton',
	radioButtons: 'input[name="action"]',
	reasonSelectWrapper: 'reasonSelectWrapper',
};
const CLASSES = {
	textareaActive: 'hide-textarea',
	disabled: 'disabled',
	hidden: 'display--none',
};

export class DeclineBooking {
	constructor() {
		this.inputSelect = document.getElementById(SELECTORS.inputSelect);
		this.textarea = document.getElementById(SELECTORS.textarea);
		this.textareaWrapper = document.getElementById(SELECTORS.textareaWrapper);
		this.countDownLength = document.getElementById(SELECTORS.countDownLength);
		this.submitButton = document.getElementById(SELECTORS.submitButton);
		this.radioButtons = document.querySelectorAll(SELECTORS.radioButtons);
		this.reasonSelectWrapper = document.getElementById(SELECTORS.reasonSelectWrapper);

		const requiredElements = [this.inputSelect, this.textareaWrapper, this.countDownLength];

		if (requiredElements.some((el) => !el)) {
			return;
		}

		this.bindEvents();
		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		new DeclineBooking();
	}

	bindEvents() {
		['displayTextarea', 'calculateLengthOfReason', 'handleRadioChange'].forEach((e) => {
			this[e] = this[e].bind(this);
		});
	}

	showCustomResponseTextarea() {
		this.textareaWrapper.classList.remove(CLASSES.textareaActive);
	}

	hideCustomResponseTextarea() {
		this.textarea.value = '';
		this.textareaWrapper.classList.add(CLASSES.textareaActive);
	}

	// calculate current len
	calculateLengthOfReason(e) {
		const currentLength = parseInt(e.target.value.length, 10);

		this.countDownLength.textContent = `${currentLength}`;

		// enable submit button if text area has more than 3 character inserted
		if (currentLength > 3) {
			this.submitButton.classList.remove(CLASSES.disabled);
		} else {
			this.submitButton.classList.add(CLASSES.disabled);
		}
	}

	displayTextarea() {
		if (this.inputSelect.value === 'other') {
			this.showCustomResponseTextarea();
			this.submitButton.classList.add(CLASSES.disabled);
		} else {
			this.submitButton.classList.remove(CLASSES.disabled);
			this.hideCustomResponseTextarea();
		}
	}

	handleRadioChange() {
		const selectedValue = document.querySelector('input[name="action"]:checked').value;

		if (selectedValue === 'request_new_dates') {
			// Hide reason select and enable submit button
			this.reasonSelectWrapper.classList.add(CLASSES.hidden);
			this.textareaWrapper.classList.add(CLASSES.textareaActive);
			this.submitButton.classList.remove(CLASSES.disabled);
			// Reset select value
			this.inputSelect.value = '';
		} else if (selectedValue === 'cancel') {
			// Show reason select and disable submit button initially
			this.reasonSelectWrapper.classList.remove(CLASSES.hidden);
			this.submitButton.classList.add(CLASSES.disabled);
			// Hide textarea if it was shown
			this.textareaWrapper.classList.add(CLASSES.textareaActive);
		}
	}

	setupEventListeners() {
		this.inputSelect.addEventListener('change', this.displayTextarea);
		this.textareaWrapper.addEventListener('input', this.calculateLengthOfReason);

		// Add radio button change listeners
		this.radioButtons.forEach((radio) => {
			radio.addEventListener('change', this.handleRadioChange);
		});
	}

	setup() {
		this.setupEventListeners();
		this.handleRadioChange();
	}
}
